
<section class="container">
  <div class="row mt-4 pb-3">

    <div class="col-12">
      <mat-card class="h-100" style="min-height: 600px;">
        <mat-card-header>
          <div class="w-100 m-3 d-flex justify-content-between align-items-center">
            <mat-form-field class="white-input-bg search">
              <mat-label>{{'search_title' | translate}}</mat-label>
              <input matInput (keyup)="applyFilter($event)" placeholder="{{'search' | translate}}" #input>
              <mat-icon matPrefix>search</mat-icon>
            </mat-form-field>

            <mat-button-toggle-group hideSingleSelectionIndicator name="gridViewOptionToggle" [(ngModel)]="gridViewOption">
              <mat-button-toggle matTooltip="List-View" (click)="changeView('list');" value="list"><mat-icon>view_list</mat-icon></mat-button-toggle>
              <mat-button-toggle matTooltip="Item-View" (click)="changeView('item');" value="item"><mat-icon>grid_view</mat-icon></mat-button-toggle>
            </mat-button-toggle-group>
          </div>
        </mat-card-header>
        <mat-card-content
          class="mx-2 h-100 drop-zone"
          [class.dragover]="isDragOver"
          (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave($event)"
          (drop)="onDrop($event)"
          >
          <ng-container>

            <!-- GRID VIEW -->
            <section [hidden]="!gridView || emptyMedia">
              <div class="containerFolders h-100 w-100 mb-4">
                @if (folder.length==0) {
                  <p>{{'empty' | translate}}</p>
                }
                @for (value of gridPagedFolder; track trackByName($index, value)) {
                  <div style="height: 150px;" class="grid-item mx-2 my-2" (click)="openFilePreview(value);">
                    @if (value?.folder) {
                      <div  matTooltip="{{value.folder}}" matTooltipShowDelay="900"  class="d-flex flex-column justify-content-between h-100">
                        @if (value?.folder) {
                          <mat-card class="folder-card">
                            <mat-card-content>
                              <div class="py-2"><span class="card-icon material-symbols-outlined">folder</span></div>
                            </mat-card-content>
                          </mat-card>
                        }
                        <div class="text-center filename" style="margin-top:-5px;">{{value.folder}}</div>
                      </div>
                    }
                    @if (value?.item) {
                      <div matTooltip="{{value.item}}" matTooltipShowDelay="900" class="d-flex flex-column justify-content-between h-100">
                        @if (checkFileType(value) == 'image') {
                          <img [src]="value.thumbnail ?? storageService.getImageThumb(value)" [alt]="value.item" width="150" height="120" style="border-radius:10px; object-fit: cover;" onerror="this.src='./../../assets/img/image_placeholder.png'">
                        }
                        @if (checkFileType(value) == 'file') {
                          <mat-card class="file-card">
                            <mat-card-content>
                              <div class="py-2">
                                <span class="card-icon material-symbols-outlined">draft</span>
                              </div>
                            </mat-card-content>
                          </mat-card>
                        }
                        @if (checkFileType(value) === 'video') {
                          <mat-card class="video-card">
                            <img
                              [src]="value.thumbnail ?? storageService.getVideoThumb(value)"
                              [alt]="value.item"
                              width="150"
                              height="120"
                              class="video-thumb"
                              onerror="this.src='./../../assets/img/video_placeholder.png'"
                              />
                            <mat-icon class="video-icon material-symbols-outlined">movie</mat-icon>
                          </mat-card>
                        }
                        <div class="text-center filename">{{value.item}}</div>
                      </div>
                    }
                  </div>
                }
              </div>
              <mat-paginator #gridPaginator [length]="filteredFolder.length" [pageSizeOptions]="paginatorSize" aria-label="Select page" showFirstLastButtons class="pb-2"></mat-paginator>
            </section>
            <!-- LIST VIEW -->
            <section [hidden]="gridView || emptyMedia" class="h-100">
              <div class="row mt-4">
                <div class="col-12 mb-4">
                  <div class="mat-elevation-z8 rounded shadow-sm" id="table-container">
                    <table mat-table [dataSource]="listdata" matSort>

                      <ng-container matColumnDef="icon" >
                        <th mat-header-cell *matHeaderCellDef> </th>
                        <td mat-cell *matCellDef="let row" (click)="openFilePreview(row);">
                          @if (checkFileType(row) == 'video') {
                            <span class="material-symbols-outlined">movie</span>
                          }
                          @if (checkFileType(row) == 'file') {
                            <span class="material-symbols-outlined">draft</span>
                          }
                          @if (checkFileType(row) == 'image') {
                            <span class="material-symbols-outlined">image</span>
                          }
                          @if (checkFileType(row) == 'folder') {
                            <span class="material-symbols-outlined">folder</span>
                          }
                        </td>
                      </ng-container>

                      <!-- name Column -->
                      <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="{{'reports.sorted_by' | translate}} {{'contentTypes.name' | translate}}"> {{'contentTypes.name' | translate}} </th>
                        <td mat-cell *matCellDef="let row" (click)="openFilePreview(row);">
                          @if (row.name) {
                            <span class="text-wrap text-break">{{row.name}}</span>
                          }
                        </td>
                      </ng-container>

                      <!-- type Column -->
                      <ng-container matColumnDef="type">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="{{'reports.sorted_by' | translate}} {{'type' | translate}}"> {{'type' | translate}} </th>
                        <td mat-cell *matCellDef="let row" (click)="openFilePreview(row);">
                          @if (row.metadata) {
                            <span class="text-wrap text-break">{{row.type}}</span>
                          }
                        </td>
                      </ng-container>

                      <!-- updated Column -->
                      <ng-container matColumnDef="updated" >
                        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="{{'reports.sorted_by' | translate}} {{'last_update' | translate}}"> {{'last_update' | translate}} </th>
                        <td mat-cell *matCellDef="let row" (click)="openFilePreview(row);" >
                          {{row?.updated | date: 'dd.MM.yyyy, HH:mm'}}
                        </td>
                      </ng-container>

                      <!-- size Column -->
                      <ng-container matColumnDef="size" >
                        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="{{'reports.sorted_by' | translate}} {{'size' | translate}}"> {{'size' | translate}} </th>
                        <td mat-cell *matCellDef="let row" (click)="openFilePreview(row);" >
                          {{ getFileSize(row?.size) }}
                        </td>
                      </ng-container>

                      <!-- Action Column -->
                      <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let row">
                          <button mat-icon-button [matMenuTriggerFor]="menu">
                            <mat-icon>more_vert</mat-icon>
                          </button>
                          <mat-menu #menu="matMenu">

                            <button mat-menu-item (click)="downloadFile(row);" ><!--[disabled]="!contentTypeUserRights_create"-->
                              <mat-icon class="material-symbols-outlined">download</mat-icon> {{'download' | translate}}
                            </button>
                            <button mat-menu-item (click)="deleteFile(row);">
                              <mat-icon class="material-symbols-outlined delete">delete</mat-icon> {{'delete' | translate}}
                            </button>
                          </mat-menu>
                        </td>
                      </ng-container>

                      <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true;" class="p-1"></tr>
                      <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="p-1 element-row text-wrap text-break"></tr>

                      <!-- Row shown when there is no matching data. -->
                      <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell" colspan="4">{{'no_matching_data' | translate}} "{{input.value}}"</td>
                      </tr>
                    </table>

                    <mat-paginator #listPaginator [pageSizeOptions]="paginatorSize" aria-label="Select page of users" showFirstLastButtons class="pb-2"></mat-paginator>
                  </div>
                </div>
              </div>
            </section>
            @if(emptyMedia){

              <section class="m-2 h-100">
                <div appDragAndDrop (files)="filesDropped($event)" class="h-100">
                  <mat-card class="upload-section text-center justify-content-center mb-4">
                    <div style="margin:0 auto; height:100%;" class="d-flex justify-content-end flex-column">
                      <div class="p-2 mb-4 text-center">
                        <mat-icon class="decoration-icon material-symbols-outlined">add_photo_alternate</mat-icon>

                        <button mat-button class="my-3 orange-button" (click)="triggerFileInput()">
                          {{'pass.browse' | translate}}
                        </button>

                        <input #fileInput type="file" id="imageFile" name="imageFile" style="display: none;" accept=".jpg, .jpeg, .png, .webp" (change)="readURL($event)">
                      </div>
                      <p class="py-2 mt-4">{{'pass.supportedFiles' | translate}}: .jpg, .jpeg, .png, .webp</p>
                    </div>
                  </mat-card>
                </div>
              </section>
            }

          </ng-container>


        </mat-card-content>
        <!-- <mat-card-actions></mat-card-actions>
        <mat-card-footer></mat-card-footer> -->
      </mat-card>
    </div>
  </div>
</section>
